import type { PayloadAction } from '@reduxjs/toolkit';

import { Locale, SET_LOCALE } from './types';

const initialState: Locale | null = null;

export function localeReducer(state = initialState, action: PayloadAction<Locale | null>): Locale | null {
	switch (action.type) {
		case SET_LOCALE:
			return action.payload;
		default:
			return state;
	}
}
